import { MailOutlined, SendOutlined } from "@ant-design/icons";
import { App, Button, Form, Input, Modal } from "antd";
import { useState } from "react";
import { sendEmail } from "../../api/emailApi";
import { getApiErrorMessage } from "../utils/apiError";

export function EmailComposeModal({ open, onClose }: { open: boolean; onClose: () => void }) {
  const { message } = App.useApp();
  const [form] = Form.useForm();
  const [sending, setSending] = useState(false);

  return (
    <Modal
      title={<><MailOutlined /> Compose Email</>}
      open={open}
      onCancel={onClose}
      confirmLoading={sending}
      okText="Send"
      okButtonProps={{ icon: <SendOutlined /> }}
      onOk={() => form.submit()}
    >
      <Form form={form} layout="vertical" onFinish={async (values) => {
        setSending(true);
        try {
          await sendEmail(values);
          message.success("Email sent");
          form.resetFields();
          onClose();
        } catch (err) {
          message.error(getApiErrorMessage(err, "Email failed"));
        } finally {
          setSending(false);
        }
      }}>
        <Form.Item name="to" label="To" rules={[{ required: true, type: "email" }]}><Input autoFocus /></Form.Item>
        <Form.Item name="subject" label="Subject"><Input /></Form.Item>
        <Form.Item name="body" label="Body"><Input.TextArea rows={8} /></Form.Item>
      </Form>
    </Modal>
  );
}
